import BottomNav from '../components/BottomNav';
import styles from './MoreScreen.module.css';

const Chevron = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M6 4L10 8L6 12" stroke="#BDBDBD" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const menuSections = [
  {
    items: [
      {
        id: 'settings',
        label: 'Settings',
        icon: (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" stroke="#6B6B6B" strokeWidth="1.5"/>
            <path d="M16.2 10c0-.3 0-.6-.1-.9l1.9-1.5c.2-.2.2-.4.1-.6l-1.8-3.1c-.1-.2-.4-.3-.6-.2l-2.2.9c-.5-.4-1-.7-1.5-.9l-.3-2.3c-.1-.2-.3-.4-.6-.4H7.9c-.3 0-.5.2-.6.4L7 4.7c-.6.2-1.1.5-1.5.9L3.3 4.7c-.2-.1-.5 0-.6.2L.9 8c-.1.2-.1.5.1.6L2.9 10c0 .3-.1.6-.1.9s0 .6.1.9L1 13.4c-.2.2-.2.4-.1.6l1.8 3.1c.1.2.4.3.6.2l2.2-.9c.5.4 1 .7 1.5.9l.3 2.3c.1.2.3.4.6.4h3.6c.3 0 .5-.2.6-.4l.3-2.3c.6-.2 1.1-.5 1.5-.9l2.2.9c.2.1.5 0 .6-.2l1.8-3.1c.1-.2.1-.5-.1-.6L16.1 11c.1-.3.1-.6.1-1z" stroke="#6B6B6B" strokeWidth="1.5"/>
          </svg>
        )
      },
      {
        id: 'notifications',
        label: 'Notifications',
        icon: (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 2a6 6 0 00-6 6v3l-1.5 2.5h15L16 11V8a6 6 0 00-6-6z" stroke="#6B6B6B" strokeWidth="1.5" strokeLinejoin="round"/>
            <path d="M8.5 16.5a1.5 1.5 0 003 0" stroke="#6B6B6B" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        )
      },
    ]
  },
  {
    items: [
      {
        id: 'help',
        label: 'Help & Support',
        icon: (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="8" stroke="#6B6B6B" strokeWidth="1.5"/>
            <path d="M7.5 7.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5c0 1-1 1.8-2 2.2V11" stroke="#6B6B6B" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="10" cy="13.5" r=".75" fill="#6B6B6B"/>
          </svg>
        )
      },
      {
        id: 'about',
        label: 'About',
        icon: (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="8" stroke="#6B6B6B" strokeWidth="1.5"/>
            <path d="M10 9v5" stroke="#6B6B6B" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="10" cy="6.5" r=".75" fill="#6B6B6B"/>
          </svg>
        )
      },
    ]
  }
];

const MoreScreen = () => {
  return (
    <div className={styles.screen}>
      <div className={styles.content}>
        <div className={styles.profile}>
          <div className={styles.avatar}>S</div>
          <div>
            <p className={styles.profileName}>Sebin M.</p>
            <p className={styles.profileEmail}>sebin.mangalan@affinity.com</p>
          </div>
        </div>

        <h1 className={styles.heading}>More</h1>

        {menuSections.map((section, si) => (
          <div key={si} className={styles.section}>
            {section.items.map((item, ii) => (
              <button
                key={item.id}
                className={`${styles.menuItem} ${ii < section.items.length - 1 ? styles.menuItemBorder : ''}`}
                onClick={() => {}}
                aria-label={item.label}
              >
                <span className={styles.menuIcon}>{item.icon}</span>
                <span className={styles.menuLabel}>{item.label}</span>
                <Chevron />
              </button>
            ))}
          </div>
        ))}

        <p className={styles.version}>Version 1.0.0 · Banking App Case Study</p>
      </div>

      <BottomNav />
    </div>
  );
};

export default MoreScreen;
